var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column justify-content-center align-content-center",attrs:{"id":"build-see-content"}},[_c('canvas',{staticStyle:{"border":"1px solid #2b97d6"},attrs:{"id":"build-see-canvas","width":`${_vm.canvasWidth}`,"height":`${_vm.canvasHeigth}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }